import React from 'react';
import gql from 'graphql-tag';
import { CheckoutOrderSummaryImageFields } from '../schemas/rql';

import BLANK_MEDIUM_IMAGE from '../../images/products/blank_medium.jpg';

interface Props {
  listing: CheckoutOrderSummaryImageFields.Listing;
}

export default function CheckoutOrderSummaryImage({ listing }: Props) {
  return (
    <img
      alt={listing.title}
      className="width-100 height-auto d-block bd-rounded"
      src={listingImageSourceOrDefault(listing)}
    />
  );
}

function listingImageSourceOrDefault(listing: CheckoutOrderSummaryImageFields.Listing) {
  const image = listing.images[0];
  return image?.source || BLANK_MEDIUM_IMAGE;
}

export const CheckoutOrderSummaryImageFragment = gql`
  fragment CheckoutOrderSummaryImageFields on Checkout {
    _id
    orders {
      listing {
        _id
        title
        images(
          input: {
            transform: "card_square"
            count: 1
            scope: "photos"
            type: "Product"
          }
        ) {
          source
        }
      }
    }
  }
`;
